<template>
  <NotificationsComponent
    v-if="notificationContext"
    :context="notificationContext"
    @notification-open-primary-email-verification="toggleVerifyPrimaryEmailAddressModal"
  />
  <slot name="content"></slot>
  <VerifyPrimaryEmailAddressComponent
    v-if="showVerifyPrimaryEmailAddressModal"
    :show-dialog="showVerifyPrimaryEmailAddressModal"
    :email="email"
    @close-modal="toggleVerifyPrimaryEmailAddressModal"
  />
</template>
<script lang="ts">
import { defineComponent, ref, computed, watch } from "vue";
import { logEvent } from "@/common/logger";
import { t } from "@/i18n";
import NotificationsComponent from "@/components/shared/Notifications.vue";
import VerifyPrimaryEmailAddressComponent from "@/components/shared/dialogs/VerifyPrimaryEmail/VerifyPrimaryEmailAddress.vue";

const name = "PrimaryEmailVerificationWrapperComponent";

export default defineComponent({
  name,
  components: {
    VerifyPrimaryEmailAddressComponent,
    NotificationsComponent,
  },
  props: {
    email: {
      type: String,
      required: true,
    },
    notificationContext: {
      type: String,
      required: true,
    },
    showDialog: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["close-dialog"],
  setup(props, context) {
    logEvent("created", name);
    const showVerifyPrimaryEmailAddressModal = ref(props.showDialog);
    const activateDialog = computed(() => props.showDialog);

    watch(activateDialog, () => {
      if (activateDialog.value === true) {
        toggleVerifyPrimaryEmailAddressModal("open");
      }
    });

    function toggleVerifyPrimaryEmailAddressModal(type: string | null) {
      type = type || "modal";
      logEvent(
        "toggleVerifyPrimaryEmailAddressModal",
        name,
        `${showVerifyPrimaryEmailAddressModal.value ? "Hiding" : "Showing"} via ${type}`
      );
      showVerifyPrimaryEmailAddressModal.value = !showVerifyPrimaryEmailAddressModal.value;
      if (!showVerifyPrimaryEmailAddressModal.value) {
        context.emit("close-dialog");
      }
    }

    return {
      t,
      showVerifyPrimaryEmailAddressModal,
      toggleVerifyPrimaryEmailAddressModal,
    };
  },
});
</script>
<style scoped lang="css">
@import "@/styles/variables.css";
</style>
